import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SaleProvider } from "../../store/saleContext";
import { ProductProvider } from "../../store/productContext";
import { CustomerProvider } from "../../store/customerContext";
import { CurrencyProvider } from "../../store/currencyContext";
import SaleFormPage from "./SaleFormPage";
import SaleListPage from "./SaleListPage";

const SaleIndexPage: React.FC = () => (
    <ProductProvider>
        <CustomerProvider>
            <CurrencyProvider>
                <SaleProvider>
                    <Routes>
                        <Route path="form" element={<SaleFormPage />} />
                        <Route path="form/:id" element={<SaleFormPage />} />
                        <Route path="list" element={<SaleListPage />} />
                        <Route index element={<Navigate to="list" replace />} />
                        <Route path="*" element={<Navigate to="list" replace />} />
                    </Routes>
                </SaleProvider>
            </CurrencyProvider>
        </CustomerProvider>
    </ProductProvider>
);

export default SaleIndexPage;
